












































































import {Component, Prop, Vue} from 'vue-property-decorator'
import textColor from '@/filters/to-text-cl-class'
import textSize from '@/filters/to-font-sz-class'
import textWeight from '@/filters/to-font-weight-class'

/**
 * display left right icon, title, notice
 */
@Component
export default class ListItem extends Vue {
  @Prop() leftIcon: string
  @Prop() rightIcon: string
  @Prop() title: string
  @Prop({default: 'gray-700'}) titleColor: string
  @Prop({default: 'subtitle'}) titleSize: string
  @Prop({default: 'normal'}) titleWeight: string
  @Prop() notice: string
  @Prop({default: false}) disabled: boolean
  @Prop({default: 'subtitle'}) noticeColor: string
  /**
   * height: height 이 auto일 경우 title, title-content style 지정
   */
  @Prop({default: '', type: String}) height: string
  /**
   * titleRightIcon: 텍스트 오른편에 아이콘이 들어가야 할 경우
   */
  @Prop({default: false}) titleRightIcon: boolean

  get classes() {
    const titleColor = textColor(this.titleColor)
    const titleSize = textSize(this.titleSize)
    const titleWeight = textWeight(this.titleWeight)
    return {
      [titleColor]: true,
      [titleSize]: true,
      [titleWeight]: true,
    }
  }

  get titleClass(): object {
    return {
      'k-pa-y-sm': this.height === 'auto',
    }
  }

  get titleContentStyle(): object {
    return {
      'white-space': this.height !== 'auto' ? 'nowrap' : ''
    }
  }

  get noticeColorName() {
    return textColor(this.noticeColor)
  }

  get leftIconName() {
    const {leftIcon} = this
    if(!leftIcon) {
      return ''
    }
    return `keep keep-${leftIcon}`
  }

  get rightIconName() {
    const {rightIcon} = this
    if(!rightIcon) {
      return ''
    }

    return `keep keep-${rightIcon}`
  }
}
